import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { AssessmentSetup } from '../../interfaces/career-setup/assessment-setup.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';

export abstract class AssessmentSetupService extends BaseService<AssessmentSetup> {
  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<AssessmentSetup>>;
  abstract override find(id: string): Observable<AssessmentSetup>;
  abstract override create(data: Partial<AssessmentSetup>): Observable<AssessmentSetup>;
  abstract override update(id: string, data: Partial<AssessmentSetup>): Observable<AssessmentSetup>;
  abstract updateStatus(id: string, isActive: boolean): Observable<AssessmentSetup>;
  abstract override delete(id: string): Observable<void>;
}
